import React, {FC, ComponentType} from "react"

import Flex from "@irati/ui/src/Flex"
import {Body, Label} from "@irati/ui/src/Typography"
import theme from "@irati/ui/src/global/theme"
import {FormattedMessage} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

import {Absolute, RelativeBody, StatusDot, Line} from "./styled"

export interface Progress {
  title: string
  text?: string
  completed?: boolean
  active?: boolean
  boldText?: string
  boldValues?: object
  component?: ComponentType
}

interface Props {
  progress: Progress[]
  small?: boolean
  inline?: boolean
}

const RenewalProgress: FC<Props> = ({progress, small, inline}) => {
  return (
    <Flex justifyContent="center">
      {progress.map((p, i) => {
        const {title, text, boldText, boldValues, completed, active, component} = p
        return (
          <>
            {i !== 0 && <Line completed={completed} step={progress.length} small={small} />}
            <StatusDot completed={completed} active={active}>
              <Icon icon={IconTypes.circleTick} color={theme.colors.greys.white} size={18} />
              {inline ? (
                <RelativeBody>
                  <Body color={theme.colors.filterChip} weight={active ? "bold" : "default"}>
                    <FormattedMessage id={title} />
                  </Body>
                </RelativeBody>
              ) : (
                <Absolute step={progress.length}>
                  <Body color={theme.colors.filterChip} weight={active ? "bold" : "default"}>
                    <FormattedMessage id={title} />
                  </Body>
                  {text && (
                    <Label small color={theme.colors.filterChip}>
                      <FormattedMessage
                        id={text}
                        values={{
                          bold: (
                            <Label weight="bold">
                              <FormattedMessage id={boldText} values={boldValues} />
                            </Label>
                          )
                        }}
                      />
                    </Label>
                  )}
                  {component}
                </Absolute>
              )}
            </StatusDot>
            {i < progress.length - 1 && <Line completed={completed} step={progress.length} small={small} />}
          </>
        )
      })}
    </Flex>
  )
}

export default RenewalProgress
